<div class="eshava-dialog-wrapper {{dialogHeight}}-height {{dialogWidth}}-width"
  [@inOutAnimation]="animationRef.animationState()"
  (@inOutAnimation.done)="animationRef.animationDone($event)">
  <div class="eshava-dialog {{dialogHeight}}-height {{dialogWidth}}-width">
    <div class="eshava-dialog-indicator">
      <ng-content select="[indicator]"></ng-content>
    </div>
    <div class="eshava-dialog-container">
      <div class="eshava-dialog-header">{{ title }}</div>
      <div class="eshava-dialog-content">
        <div class="eshava-dialog-body-wrapper {{dialogHeight}}-height"
          [class.eshava-dialog-body-with-scroll-spy]="hasScrollSpy">
          <div class="eshava-dialog-shadow"
          [class.eshava-dialog-shadow-top]="bodyTopShadow"></div>
          <div class="eshava-dialog-shadow"
          [class.eshava-dialog-shadow-bottom]="bodyBottomShadow"></div>
          <div class="eshava-dialog-body {{dialogHeight}}-height"
            #modalBody
            (scroll)="onBodyScroll($event)">
            <ng-content select="[content]"></ng-content>
          </div>
        </div>
        @if (hasScrollSpy) {
          <div
            class="eshava-scroll-spy-wrapper">
            <div class="eshava-shadow"
            [class.eshava-shadow-top]="scrollSpyTopShadow"></div>
            <div class="eshava-shadow"
            [class.eshava-shadow-bottom]="scrollSpyBottomShadow"></div>
            <div #modalScrollSpy
              (scroll)="onScrollSpyScroll($event)"
              class="eshava-scroll-spy">
              <ng-content select="[scrollspy]"></ng-content>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="eshava-dialog-footer">
      <ng-content select="[footer]"></ng-content>
    </div>
    <div class="eshava-dialog-banner">
      <ng-content select="[banner]"></ng-content>
    </div>
  </div>
  <div class="eshava-dialog-sidepanel {{dialogHeight}}-height {{dialogWidth}}-width"
    [class.eshava-show-sidepanel]="!hideSidePanel"
    [class.eshava-animate-sidepanel]="animateSidepanel"
    [style.width.px]="!hideSidePanel ? sidePanelWidth : 0">
    <div class="eshava-dialog-sidepanel-header">{{ sidepanelTitle }}</div>
    <div class="eshava-dialog-sidepanel-content {{dialogHeight}}-height {{dialogWidth}}-width">
      <ng-content select="[sidepanel]"></ng-content>
    </div>
  </div>
</div>